import React, { useState, useEffect, useRef } from 'react'
import {
  ChakraProvider,
  Box,
  Center,
  Text,
  Button,
  Card,
  Image,
  Flex,
  Slide,
} from '@chakra-ui/react'
import ImageCarousel from './ImageCarousel'
import Slideshow from './Slideshow'

const BintusStoreProjectScreen = () => {
  const [index, setIndex] = useState(0)
  const timeoutRef = useRef(null)
  const delay = 2500

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
  }

  useEffect(() => {
    resetTimeout()
    timeoutRef.current = setTimeout(
      () =>
        setIndex((prevIndex) =>
          prevIndex === projectDetails.length - 1 ? 0 : prevIndex + 1
        ),
      delay
    )

    return () => {
      resetTimeout()
    }
  }, [index])

  const projectDetails = [
    '/bintus store pic.jpeg',
    '/bintusstore pic2.jpeg',
    '/bintusstore pic3.jpeg',
    '/bintusstore pic4.jpeg',
    '/bintusstore pic 5.jpeg',
  ]
  const projectStack = [
    {
      stackImgSrc: 'fa-brands fa-react',
      stackName: 'Reactjs',
    },
    {
      stackImgSrc: 'fa-brands fa-css3-alt',
      stackName: 'CSS',
    },
    {
      stackImgSrc: 'fa-solid fa-database',
      stackName: 'MongoDB',
    },
    {
      stackImgSrc: 'fa-brands fa-node',
      stackName: 'Expressjs',
    },
  ]
  return (
    <ChakraProvider>
      <Box
        w={{
          base: '90%',
          sm: '90%',
          md: '90%',
          lg: '90%',
          xl: '90%',
        }}
        alignContent='center'
        mx='auto'
        h={{
          base: 'auto',
          sm: 'auto',
          md: 'auto',
          lg: 'auto',
          xl: 'auto',
        }}>
        <Center>
          <Text
            fontSize={{
              base: '30px',
              sm: '30px',
              md: '35px',
              lg: '35px',
              xl: '35px',
            }}
            fontFamily='Inter'
            letterSpacing='5px'
            my='50px'>
            {' '}
            Bintus Store
          </Text>
        </Center>

        <div className='slideshow'>
          <div
            className='slideshowSlider'
            style={{ transform: `translate3d(${-index * 100}%, 0, 0)` }}>
            {projectDetails.map((backgroundColor, index) => (
              <div className='slide' key={index}>
                <Image src={backgroundColor} />
              </div>
            ))}
          </div>

          <div className='slideshowDots'>
            {projectDetails.map((_, idx) => (
              <div
                key={idx}
                className={`slideshowDot${index === idx ? ' active' : ''}`}
                onClick={() => {
                  setIndex(idx)
                }}></div>
            ))}
          </div>
        </div>
        <Center>
          <Text
            fontSize={{
              base: '30px',
              sm: '30px',
              md: '35px',
              lg: '35px',
              xl: '35px',
            }}
            textAlign='center'
            fontFamily='Inter'
            letterSpacing='5px'
            mt='50px'>
            {' '}
            About Bintus Store
          </Text>
        </Center>
        <Center>
          <Text fontFamily='Roboto mono' letterSpacing='5px' my='30px'>
            Bintus store clothing app is a clothing store e-commerce website.
            Users can create accounts to enable them make instant purchases and
            add items to cart to purchase in bulk or later.
          </Text>
        </Center>
        <Box my='50px'>
          <Center>
            <Text
              fontSize={{
                base: '35px',
                sm: '35px',
                md: '25px',
                lg: '25px',
                xl: '25px',
              }}
              fontFamily='Inter'
              letterSpacing='5px'
              my='50px'>
              {' '}
              Stack
            </Text>
          </Center>
          <Center>
            <Flex
              textAlign='center'
              direction={{
                base: 'column',
                sm: 'column',
                md: 'row',
                lg: 'row',
                xl: 'row',
              }}
              gap='30px'
              w='auto'>
              {projectStack.map((projectDetail, index) => (
                <Box maxW='sm' key={index} textAlign='center'>
                  <i class={projectDetail.stackImgSrc}></i>{' '}
                  {projectDetail.stackName}
                </Box>
              ))}
            </Flex>
          </Center>
        </Box>

        <Box my='50px'>
          <Center>
            <Text
              fontSize={{
                base: '35px',
                sm: '35px',
                md: '25px',
                lg: '25px',
                xl: '25px',
              }}
              fontFamily='Inter'
              letterSpacing='5px'
              my='50px'>
              {' '}
              Project Links
            </Text>
          </Center>
          <Center>
            <Flex textAlign='center' direction='column' gap='30px' w='auto'>
              <Button colorScheme='teal' variant='solid'>
                <a href='https://github.com/bintus-ux/bintus-store-frontend-site'>
                  Git Frontend
                </a>
              </Button>
              <Button colorScheme='teal' variant='solid'>
                <a href='https://github.com/bintus-ux/bintus-store-frontend-site'>
                  Git Backend
                </a>
              </Button>
              <Button colorScheme='teal' variant='solid'>
                <a href='https://bintusstore.vercel.app/'>Live Link</a>
              </Button>
            </Flex>
          </Center>
        </Box>
      </Box>
    </ChakraProvider>
  )
}

export default BintusStoreProjectScreen
